import React from "react"
import type { OBRequestTask } from "@/types/workflow"
import { useTranslation } from "@/hooks/use-translation"
import { buildLegendEntries } from "./org-type-colors"

interface LegendStripProps {
  tasks: OBRequestTask[]
}

export function LegendStrip({ tasks }: LegendStripProps) {
  const { t } = useTranslation()
  const actorTypes = tasks.flatMap(t => (t.actors ?? []).map(a => a.actorType))
  const entries = buildLegendEntries(actorTypes)

  if (entries.length === 0) return null

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "4px 12px",
      borderBottom: "1px solid #F1F5F9",
      backgroundColor: "#FAFAFA",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        {entries.map((entry, i) => {
          const label = entry.fallbackLabel ?? t(entry.labelKey)
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: entry.color, flexShrink: 0 }} />
              <span style={{ fontSize: 11, color: "#64748B" }}>{label}</span>
            </div>
          )
        })}
      </div>
      <span style={{ fontSize: 10, color: "#94A3B8", whiteSpace: "nowrap", marginLeft: 8 }}>
        {t('rppDragHoverHint')}
      </span>
    </div>
  )
}
